export enum EModuleCode {
  AttendanceManagement = "AM",
  CompanySetup = "CS",
  EmployeeServices = "ES",
  HRAssistant = "HA",
  PeopleCentral = "PC",
  SystemConfiguration = "SC",
  UserManagement = "UM",
  PayrollSetup = "PR",
  Reports = "RP",
  Performance = "PF",
  Recruitment = "RC",
  EmployeeTaskAssignment = "ETA",
  CLOSING_SALARY_REPORTS = "CSP",
}

export enum EModuleFeatureCode {
  // company setup
  company = "COM",
  companyBranch = "COB",
  department = "DEP",
  job = "JOB",
  position = "POS",
  grade = "GS",

  // system configuration
  permissionType = "PET",
  leaveType = "LET",
  workflow = "WOF",
  travelRequest = "TRL",
  workFromHomeConfig = "WFHC",
  businessMissionConfiguration = "BMPC",

  // people central
  employee = "EMP",
  onBoardConfig = "TCO",
  onboarding = "ETA",

  // hr assistant
  companyFile = "COF",

  // employee services
  leave = "LEA",
  leaveReq = "LER",
  permission = "PEN",
  permissionReq = "PER",
  workFromHomeReq = "WFH",
  workFromHome = "WFHE",
  BusinessMission = "BME",
  BusinessMissionRequest = "BMR",
  WorkOnVacationOrder = "WOV",
  WorkOnVacationOrderRequest = "WVR",
  WorkOnVacationConsideration = "WVCE",
  WorkOnVacationConsiderationRequest = "WVC",
  OvertimeAmountSubmission = "OAS",
  OvertimeAmountSubmissionRequest = "OAR",
  TravelAdminRequest = "TRL",
  TravelEmployeeReq = "TRLR",

  // attendance management
  eligibility = "ELI",
  rotationGroup = "ROG",
  workSchedule = "WOS",
  yearlyHoliday = "YEH",
  user = "USE",
  policy = "POL",
  attendance = "ATT",
  attendanceTransaction = "ATR",

  //recruitement
  candidates = "CND",

  // payroll setup
  Bank = "BNK",
  ElementBatch = "ELB",
  EmployeeBatch = "EMB",
  BatchManagement = "EMB",
  ExchangeRate = "EXR",
  PayrollDefinition = "PRL",
  PayrollElement = "ELM",
  PayrollRun = "PRR",
  SalaryStructure = "SST",
  SocialInsurance = "SoI",
  TaxRule = "TXR",

  // Reports
  EmployeeDailyStatus = "RP",

  // Performance
  Competencies = "CMP",
  AssignCompetencies = "ACMP",
  EmployeeAssignCompetencies = "EACMP",
  EvaluationConfig = "EVL",
  Evaluations = "EVL",
  CLOSING_SALARY_REPORTS = "CSP",
  CLOSING_SALRY_REPORT_WORKFLOW = "CMP",
}
